import React, { useCallback } from 'react';
import { t } from '@lingui/macro';
import { InstrumentationOptions } from 'types';
import { Sample } from 'types/generated/graphql';

const useSelectorButton = ({
    instrumentationOptions,
    sample,
    onClick,
    label,
}: {
    sample: Sample;
    instrumentationOptions: InstrumentationOptions;
    onClick?: (event?: React.MouseEvent) => void;
    label?: string;
}): {
    handleOnClick: (event?: React.MouseEvent<Element>) => void;
    labelText: string;
} => {
    const handleOnClick = useCallback(
        (event?: React.MouseEvent<Element>) => {
            onClick && onClick(event);
        },
        [sample, instrumentationOptions, onClick],
    );

    const labelText = label || t`Find similar samples`;

    return { handleOnClick, labelText };
};

export default useSelectorButton;
